export default {
  NAVIGATION_REQUEST: 'NAVIGATION_REQUEST',
  NAVIGATION_SUCCESS: 'NAVIGATION_SUCCESS',
  NAVIGATION_FAILURE: 'NAVIGATION_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/NavigationConstants.js